import getScript from './getScript'
import { outerWidth, outerHeight } from './htmlElement'

class PlayerYouku {
    constructor() {
        this.iframeApi = new Promise(resolve => {
            getScript('https://player.youku.com/jsapi').then(() => resolve())
        })
    }

    attach(iframeContainerId, videoId, isBackgroundVideoPlaying, isAutoPlay = 1, moreParams = {}) {
        let params = {}
        if (isBackgroundVideoPlaying) {
            const container = document.getElementById(iframeContainerId)

            params = {
                playlist: videoId,
                controls: 0,
                loop: 1,
                autoplay: 1,
                width: outerWidth(container),
                height: outerHeight(container)
            }
        }
        return new Promise(resolve => {
            this.iframeApi.then(() => {
                const player = new window.YKU.Player(iframeContainerId, {
                    styleid: '0',
                    client_id: 'a3660779c8b57c32',
                    vid: videoId,
                    newPlayer: true,
                    autoplay: isAutoPlay,
                    show_related: false,
                    width: 640,
                    height: 360,
                    ...params,
                    ...moreParams,
                    events: {
                        onPlayerReady: () => resolve(player),
                        onPlayStart: () => ({}),
                        onPlay: () => ({}),
                        onPlayEnd: () => ({}),
                        onPause: () => ({}),
                        onWaiting: () => ({}),
                        onFullScreen: () => ({}),
                        onPlayError: () => ({})
                    }
                })
            })
        })
    }
}

export default PlayerYouku
